import { useEffect, useState } from 'react'
import { emmiter } from '@yuno/dashboard'

const isDevEnvironment =
  process.env.ENVIRONMENT === 'LOCAL' || process.env.ENVIRONMENT === 'DEV'

export const useInactiveSession = () => {
  const [countDown, setCountDown] = useState(1)
  const [showInactiveDialog, setShowInactiveDialog] = useState(false)

  useEffect(() => {
    if (!isDevEnvironment) {
      emmiter.subscribe('inactiveTimer', (e: any) => {
        const time = e?.detail?.timer
        if (time <= 300) {
          setCountDown(time)
        }
      })

      return emmiter.unsubscribe('inactiveTimer')
    }
  }, [])

  useEffect(() => {
    if (!isDevEnvironment) {
      emmiter.subscribe('showInactiveDialog', (e: any) => {
        setShowInactiveDialog(e?.detail?.showInactiveDialog)
      })

      return emmiter.unsubscribe('showInactiveDialog')
    }
  }, [])

  const handleResetTimer = () => {
    emmiter.dispatch('resetTimer', {
      detail: { reset: true },
    })
    emmiter.dispatch('showInactiveDialog', {
      detail: { showInactiveDialog: false },
    })
  }

  const handleEvent = () => {
    if (!showInactiveDialog) {
      handleResetTimer()
    }
  }

  return {
    showInactiveDialog,
    handleResetTimer,
    countDown,
    handleEvent,
  }
}
